import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportDatesWithActivityType } from 'types/reportsDates';

export type EddrState = Readonly<{
  reportDates: Record<string, string[] | null | undefined>;
  reportDatesWithType: Record<string, ReportDatesWithActivityType[]>
}>;

export const initialState: EddrState = { reportDates: {} , reportDatesWithType: {}};

const eddrSlice = createSlice({
  name: 'Eddr',
  initialState,
  reducers: {
    updateEddr: (state, action: PayloadAction<{ tuwi: string; dates: string[]; reportDatesWithType: ReportDatesWithActivityType[] }>) => {
      state.reportDates[action.payload.tuwi] = action.payload.dates;
      state.reportDatesWithType[action.payload.tuwi] = action.payload.reportDatesWithType;
    },
  },
});

export const { updateEddr } = eddrSlice.actions;
export default eddrSlice.reducer;
